<template>
  <el-dialog
    :model-value="modelValue"
    :title="$t('barcode_notification')"
    width="90%"
    top="0"
    :show-close="true"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    :destroy-on-close="false"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <p class="notification-message">{{ message }}</p>
    <template #footer>
      <el-button @click="$emit('remove')">{{ $t('remove_from_list') }}</el-button>
      <el-button type="primary" @click="$emit('confirm')">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  components: {},
  name: 'BarcodeNotificationDialog',
  emits: ['update:modelValue', 'confirm', 'remove'],
})
export default class BarcodeNotificationDialog extends Vue {
  @Prop({ type: Boolean, required: true }) readonly modelValue!: boolean
  @Prop({ type: String, default: '' }) readonly message!: string
}
</script>

<style lang="scss" scoped>
@import './src/assets/css/mixins.scss';
</style>
